export default __webpack_public_path__ + "static/media/kpop.62859fc5.png";